import React from 'react';
import { useNavigate } from 'react-router';
import logo from '../Assets/compass-logo.svg';
import { TbArrowBigLeftLineFilled } from "react-icons/tb";
import Lottie from 'lottie-react';
import animationData from '../404.json'

const NotFound:React.FC = () => {
  const navigate = useNavigate();

  // To take user back to the previous page
  const backToPreviousPage = () => {
    navigate(-1);
  }

  return (
    <section className='w-full bg-lime-200'>
      <div className='w-full fixed top-0 left-0 py-4 z-40'>
        <div className='container mx-auto flex items-center justify-between'>
          <img className='w-[120px] md:w-[157px]' src={logo} alt='logo' />
          <div onClick={backToPreviousPage} className='flex items-center gap-2 text-darkGreen cursor-pointer'>
            <TbArrowBigLeftLineFilled size={25} />
            <p className='font-bold flex gap-[2px]'>Back <span className='hidden md:block'>to previous page</span></p>
          </div>
        </div>
      </div>
      <div className='container h-[100vh] flex items-center justify-center lg:pt-[90px]'>
        <Lottie className='w-[85%] lg:w-[40%]' animationData={animationData} loop={true} />
      </div>
    </section>
  )
}

export default NotFound